import $ from 'jquery';
import {ENDERECO_API} from '../../config/constant';
import {decode as base64_decode, encode as base64_encode} from 'base-64';

const RestRelatoriosPost = (config) => {
  const Arr_ = JSON.parse(config.data);
  const caminho = (Arr_.dest ?? '')
    .toString()
    // remove espaços e caracteres invisíveis que podem vir do frontend/build
    .replace(/[\s\u200B-\u200D\uFEFF\u0000]/g, '')
    .trim();

  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];

  // Relatórios NFS-e por Grupo de Serviço LC 116/2003: expressNfseGrupo01 ... expressNfseGrupo99
  if (/^expressNfseGrupo\d{2}$/.test(caminho)) {
    return new Promise(function (resolve, reject) {
      const {dataPost} = JSON.parse(config.data);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode(caminho),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: function (data, _status, _xhr) {
            resolve([200, data]);
          },
          error: function (_xhr, _status, _error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err + ' Server Error'}]);
      }
    });
  }

  switch (caminho) {
    case 'sugestaoRelatorio':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);

        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('sugestaoRelatorio'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, _status, _xhr) {
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'deletaConfigTabela':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);

        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('deletaConfigTabela'),
              dd: base64_encode(JSON.stringify(dataPost_)),
              // act: 'deletaConfigTabela',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, _status, _xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'geraRelatorio':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);

        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('geraRelatorio'),
              dd: base64_encode(JSON.stringify(dataPost_)),
              // act: 'geraRelatorio',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              //
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'geraRelatorioExpress':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);

        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('geraRelatorioExpress'),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
   
    case 'expressCteListagemCompleta':
    case 'expressCteTopTransportadoras':
    case 'expressCteTopRemetentes':
    case 'expressCteTopDestinatarios':
    case 'expressCteEvolucaoMensal':
    case 'expressCteTopCFOP':
    case 'expressCteTopModais':
    case 'expressCteListagemCancelados':
    case 'expressCteListagemDenegados':
    case 'expressNfeCanceladas':
    case 'expressNfeDenegadas':
    case 'expressNfeFinalidades':
    case 'expressGetColunas':    
    case 'expressSaveModelo':
    case 'expressMatrizComplexidadeFiscalNfeRecebidas':
    case 'expressRankingPrazosFornecedor':
    case 'expressListagemPagamentos':
    case 'expressDuplicatasVencer':
    case 'expressDuplicatasProximos30Dias':
    case 'expressFaturasAnalise':
    case 'expressNfseListagemCompleta':
    case 'expressNfseTopPrestadores':
    case 'expressNfseTopTomadores':
    case 'expressNfseEvolucaoMensal':
    case 'expressNfseTopServicos':
    case 'expressNfseTotaisImpostos':
    case 'expressNfseTopPrefeituras':
    case 'expressNfseNARetencoes':
    case 'expressNfseNAMapaRiscoCards':
    case 'expressNfseNAMapaRiscoTabela':
    case 'expressNfseNAIssInconsistente':
    case 'expressNfseNASimplesNacional':
    case 'expressNfseNARiscoPorMunicipio':
    case 'expressNfseNATiposRisco':
    case 'expressNfseNAPrestadoresExposicao':
    case 'expressNfseNAEvolucaoMensal':
    case 'expressNfseNADashboard':
    case 'downloadXmlsNfseNA':
    case 'downloadXmlsNfse':
    case 'downloadXmlsNfe':
    case 'getMaisUsadosNfe':
    case 'downloadXmlsCte':
    case 'getMaisUsadosCte':
    case 'getZipConfigUsuario':
    case 'saveZipConfigUsuario':
    case 'getPlanoOrganizadorZip':
    case 'buscarCfops':
    case 'buscarNcms':
    case 'expressNfceListagemCompleta':
    case 'expressNfceTotaisImpostos':
    case 'expressNfeComDifal':
    case 'expressNfeComFcp':
    case 'expressNfeMedicamentos':
    case 'expressNfeCombustiveis':
    case 'expressNfeVeiculos':
    case 'expressNfeExportacao':
    case 'expressNfeImportacao':
    case 'expressAnaliseCfop':
    case 'expressAnaliseCstIcms':
    case 'expressAnaliseCstPisCofins':
    case 'expressNcmCfopCruzado':
    case 'expressNfePorUfOrigem':
    case 'expressNfePorUfDestino':
    case 'expressFluxoInterestadual':
    case 'expressCceListagem':
    case 'expressNfceTopMunicipios':
    case 'expressNfceTopEmitentes':
    case 'expressNfceEvolucaoMensal':
    case 'expressNfceTopDestinatarios':
    case 'topRelatoriosUsados':
    case 'registrarExecucaoRelatorio':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode(caminho),
              dd: base64_encode(JSON.stringify(dataPost_)),
            },
            success: async function (data, status, xhr) {
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'geraRelatorioCte':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Get',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('geraRelatorioCte'),
              dd: base64_encode(JSON.stringify(dataPost_)),
              // act: 'geraRelatorioCte',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, status, xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'salvaConfigTabela':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        dataPost.push(storage[7]);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('updateConfigTabela'),
              dd: base64_encode(JSON.stringify(dataPost_)),

              // act: 'updateConfigTabela',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, _status, _xhr) {
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'salvaConfigTabelaCte':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          /* props: users,
                      pesq: dataPost*/

          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('updateConfigTabelaCte'),
              dd: base64_encode(JSON.stringify(dataPost_)),
              // act: 'updateConfigTabelaCte',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, _status, _xhr) {
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });
    case 'setModeloPadrao':
      return new Promise(function (resolve, reject) {
        const {dataPost} = JSON.parse(config.data);
        dataPost.push(storage[7]);
        const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
        try {
          $.ajax({
            // xhrFields: { withCredentials: true },
            url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
            type: 'Post',
            dataType: 'json',
            headers: {
              Authorization: 'Bearer ' + token,
            },
            data: {
              pp: base64_encode('relatorios'),
              ll: base64_encode('setModeloPadrao'),
              dd: base64_encode(JSON.stringify(dataPost_)),
              // act: 'setModeloPadrao',
              // key: emp,
              // ukey: uid,
              // dataPost: dataPost,
            },
            success: async function (data, _status, _xhr) {
              data = base64_decode(data);
              resolve([200, data]);
            },
            error: function (xhr, status, error) {
              reject([400, {message: 'erro'}]);
            },
          });
        } catch (err) {
          reject([500, {message: err + ' Server Error'}]);
        }
      });

    default:
      return [200, {erro: `Relatório não configurado no fluxo (dest: ${caminho})`}];
    
  }
};

const RestRelatoriosGet = (config) => {
  const caminho = config.dest.trim();
  const usersRt = base64_decode(sessionStorage.getItem(`ddesp`));
  const storage = JSON.parse(usersRt);
  const emp = storage[0];
  const uid = storage[3];
  const token = storage[14];
  if (caminho === 'getConfigTableRelNfe') {
    return new Promise(function (resolve, reject) {
      const dataPost_ = [base64_encode(emp), base64_encode(uid)];
      try {
        $.ajax({
          // xhrFields: { withCredentials: true },
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('getConfigTableRelNfe'),
            dd: base64_encode(JSON.stringify(dataPost_)),
            // act: 'getConfigTableRelNfe',
            // key: emp,
            // ukey: uid,
          },
          success: async function (data, status, xhr) {
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'getConfigTableRelCte') {
    return new Promise(function (resolve, reject) {
      const dataPost_ = [base64_encode(emp), base64_encode(uid)];
      try {
        $.ajax({
          // xhrFields: { withCredentials: true },
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('getConfigTableRelCte'),
            dd: base64_encode(JSON.stringify(dataPost_)),
            // act: 'getConfigTableRelCte',
            // key: emp,
            // ukey: uid,
          },
          success: async function (data, status, xhr) {
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'getModelos') {
    //  pp: base64_encode('nfe'),
    //           ll: base64_encode('deleteMarcadores'),
    //           dd: base64_encode(JSON.stringify(dataPost_)),
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);

      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          // xhrFields: { withCredentials: true },
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('getModelos'), // 'getModelos',
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'getDownloads') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);

      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          // xhrFields: { withCredentials: true },
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('getDownloads'), // 'getModelos',
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedores') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedores'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresProdutos') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresProdutos'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresProdutosLista') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresProdutosLista'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresFinanceiro') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresFinanceiro'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedorFinanceiroDetalhado') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedorFinanceiroDetalhado'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresRiscos') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresRiscos'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'nfesFornecedores') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;

      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('nfesFornecedores'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresEvolucao') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresEvolucao'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedoresEvolucaoProduto') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedoresEvolucaoProduto'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'nfesPorFlag') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('nfesPorFlag'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedorDuplicatasLista') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedorDuplicatasLista'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedorPagamentosLista') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedorPagamentosLista'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'fornecedorFaturasLista') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('fornecedorFaturasLista'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  } else if (caminho === 'nfesCanceladas') {
    return new Promise(function (resolve, reject) {
      const {dataPost} = config;
      dataPost.push(storage[7]);
      const dataPost_ = [base64_encode(emp), base64_encode(uid), base64_encode(JSON.stringify(dataPost))];
      try {
        $.ajax({
          url: `${ENDERECO_API}src/api/controller/espiaoCtrl.class.php`,
          type: 'Get',
          dataType: 'json',
          headers: {
            Authorization: 'Bearer ' + token,
          },
          data: {
            pp: base64_encode('relatorios'),
            ll: base64_encode('nfesCanceladas'),
            dd: base64_encode(JSON.stringify(dataPost_)),
          },
          success: async function (data, status, xhr) {
            data = JSON.parse(base64_decode(data));
            resolve([200, data]);
          },
          error: function (xhr, status, error) {
            reject([400, {message: 'erro'}]);
          },
        });
      } catch (err) {
        reject([500, {message: err}]);
      }
    });
  }
};

export {RestRelatoriosGet, RestRelatoriosPost};
